import React from 'react'
import { useRoutes, useNavigate, useLocation } from 'react-router-dom'
import { dashboardRoutes } from 'routes/dashboard'
import { useStoreon } from 'storeon/react'
import {
	Toolbar,
	Drawer,
	IconButton,
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Tooltip,
	Box
} from '@material-ui/core'
import {
	ChevronLeft,
	ChevronRight,
	Menu as MenuIcon,
	Computer,
	ControlPointOutlined,
	TableChart,
	QuestionAnswerOutlined,
	ViewModule
} from '@material-ui/icons'
import { DashboardContainer, DashboardMain } from './DashboardLayout.style'
import { Header } from './components/Header'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import DashboardIcon from '@material-ui/icons/Dashboard'

const drawerWidth = 240

const menuItems = [
	{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
	{ text: 'Monitor', icon: <Computer />, path: '/Monitor' },

	{ text: 'Sections', icon: <TableChart />, path: '/Sections' },
	{
		text: 'Sub Sections',
		icon: <ViewModule sx={{ fontSize: '28px', marginLeft: '-3px' }} />,
		path: '/Sub-Sections'
	},
	{ text: 'Question Bank', icon: <QuestionAnswerOutlined />, path: '/QuestionBank' }
]

const useStyles = makeStyles(theme => ({
	listItemText: {
		color: theme.palette.mode === 'dark' ? '#fff' : '#000'
	},
	selectedItemText: {
		fontWeight: 600,
		color: theme.palette.mode === 'dark' ? '#fff' : '#764bf9'
	},
	selectedItem: {
		// borderRadius: 8
	},
	selectedIcon: {
		color: '#764bf9 !important'
	},
	listItemIcon: {
		minWidth: 'auto'
	}
}))

export const DashboardLayout: React.FC = () => {
	const routes = useRoutes(dashboardRoutes)
	const navigate = useNavigate()
	const location = useLocation()
	const theme = useTheme()
	const { dispatch, user, theme: appTheme } = useStoreon('user', 'theme')

	const [drawerOpen, setDrawerOpen] = React.useState(false)

	const toggleDrawer = () => {
		setDrawerOpen(prev => !prev)
	}

	const classes = useStyles()

	return (
		<>
			<Header
				firstName={user?.firstName}
				lastName={user?.lastName}
				photoUrl={user?.photoUrl}
				openDrawer={toggleDrawer}
				isDark={appTheme === 'dark'}
				toggleTheme={() => dispatch('theme/switch')}
				signOut={() => dispatch('user/signOut')}
			/>
			<DashboardContainer>
				<Drawer
					variant="permanent"
					open={drawerOpen}
					style={{
						width: drawerOpen ? drawerWidth : 72,
						flexShrink: 0,
						whiteSpace: 'nowrap',
						transition: 'width 0.3s ease-in-out'
					}}
					PaperProps={{
						style: {
							width: drawerOpen ? drawerWidth : 60,
							overflowX: 'hidden',
							transition: 'width 0.3s ease-in-out'
						}
					}}
				>
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
							padding: '80px 6px 0px',
							alignItems: 'center'
						}}
					>
						<IconButton onClick={toggleDrawer}>
							{drawerOpen ? (
								theme.direction === 'rtl' ? (
									<ChevronRight />
								) : (
									<ChevronLeft />
								)
							) : (
								<MenuIcon />
							)}
						</IconButton>
					</div>
					<Divider />
					<List>
						{menuItems.map(item => {
							const isSelected = location.pathname === item.path

							return (
								<Tooltip key={item.text} title={item.text} placement="right" arrow>
									<ListItem
										button
										onClick={() => navigate(item.path)}
										selected={isSelected}
										className={isSelected ? classes.selectedItem : ''}
										sx={{
											paddingLeft: '12px',
											paddingRight: '12px',
											minHeight: 48
										}}
									>
										<Box display="flex" alignItems="center" gap={drawerOpen ? 1 : 1}>
											<ListItemIcon
												className={`${classes.listItemIcon} ${
													isSelected ? classes.selectedIcon : ''
												}`}
												sx={{
													pl: drawerOpen ? 1 : 0.7
												}}
											>
												{item.icon}
											</ListItemIcon>
											{drawerOpen && (
												<ListItemText
													primary={item.text}
													primaryTypographyProps={{
														className: isSelected
															? classes.selectedItemText
															: classes.listItemText,
														noWrap: true
													}}
												/>
											)}
										</Box>
									</ListItem>
								</Tooltip>
							)
						})}
					</List>
				</Drawer>

				<DashboardMain>
					<Toolbar />
					{routes}
				</DashboardMain>
			</DashboardContainer>
		</>
	)
}

export default DashboardLayout
